module.exports = __webpack_public_path__ + "static/media/Agaty1.6d15b753.png";